import { render, staticRenderFns } from "./guidedoc.vue?vue&type=template&id=4fc58af6&scoped=true&"
import script from "./guidedoc.vue?vue&type=script&lang=js&"
export * from "./guidedoc.vue?vue&type=script&lang=js&"
import style0 from "./guidedoc.vue?vue&type=style&index=0&id=4fc58af6&prod&lang=scss&scoped=true&"
import style1 from "./guidedoc.vue?vue&type=style&index=1&id=4fc58af6&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fc58af6",
  null
  
)

export default component.exports